export default {
    gettimes() {
        var timestamp = Date.parse(new Date());
        timestamp = timestamp / 1000;
        //console.log('timestamp', timestamp);
        return timestamp;
    },
    setcache(cachename, value, expire) {
        var tmp = {
            "value": value,
            'expire': this.gettimes() + expire
        };
        //console.log('setcache', JSON.stringify(tmp));
        try {
            sessionStorage.setItem(cachename, JSON.stringify(tmp));
        } catch (e) {
            console.log(e)
        }
    },
    getcache(cachename) {
        try {
            var value = sessionStorage.getItem(cachename);
            value = JSON.parse(value);
            if (value.value && value.expire) {
                if (this.gettimes() < value.expire) {//没有过期
                    //console.log('cache没有过期', value.value);
                    return value.value;
                } else {
                    //console.log('cache已过期', this.gettimes(), value.expire, value, value);
                    return false;
                }
            } else {
                //console.log('本地无cache');
                return false;
            }
        } catch (e) {
            //console.log('getcache失败');
            return false
            // Do something when catch error
        }
    },
    updatecache(cachename, expire) {
        try {
            var value = sessionStorage.getItem(cachename);
            value = JSON.parse(value);
            if (value.value && value.expire) {
                if (this.gettimes() < value.expire) {//没有过期
                    //console.log('cache没有过期可以续期', value.value);
                    //return value.value;
                    this.setcache(cachename, value.value, expire);
                } else {
                    //console.log('cache已过期不能续期', this.gettimes(), value.expire, value, value);
                    //return '';
                }
            } else {
                //console.log('本地无cache，不能续期');
                //return '';
            }
        } catch (e) {
            //console.log('getcache失败，不能续期');
            //return ''
            // Do something when catch error
        }
    }
}